import React, { useState, useEffect } from "react";
import QuantitySelector from "../quantitySelector/quantitySelector";
import Cartbtn from "../addToCartButton/cartBtn";
import { toastMsg } from "../toastMessage/toastMessage";
import styles from "./cartButtons.scss";
import cartIcon from "./assets/shopping-cart.png";
import "./cartButtons.css";
import { addToCart } from "../../utils/apis";
import { MARKUP_PURCHASE } from '../../utils/Constants/Constants';
import { useDispatch, useSelector } from "react-redux";
// import { updateCartDetails } from "@tw/header-footer/lib/redux/reducers";
import { getNonStrictVariantsLS, getMarkupPurchaseInfo, getMarkupMaxQuantityInfo } from "../../utils/helper";
import { trackAddToCart, ttqTrackEventBuryingPoint } from "../../utils/analytics";
import { getRouter } from "../../utils/helper";
import QuantityReminderPopup from "../QuantityReminderPopup/QuantityReminderPopup";

function CartButtons({
  productInfo,
  initialQuantity,
  onSuccess,
  handleQuantityChange,
  disableAddToCart,
  onAddToCart,
  updateCartDetails,
  pageDetails,
  btnLoading
}) {
  const { itemCode } = productInfo || {};
  const [quantity, setQuantity] = useState(initialQuantity || 1);
  const [isLoading, setIsLoading] = useState(false);
  const breakpoint = useSelector((state) => state.breakpoint);
  useEffect(() => {
    setIsLoading(btnLoading)
  }, [btnLoading])
  const router = getRouter();
  const handleQuantity = (quan) => {
    setQuantity(quan);
    handleQuantityChange(quan);
  };
  const dispatch = useDispatch();

  const addToCartHandle = async () => {
    try {
      setIsLoading(true);
      if (onAddToCart && typeof onAddToCart === "function") {
        onAddToCart(productInfo);
        return;
      }

      // If product is related to 1+N bundle redirect to promotion page
      if (productInfo?.bundlePromoCode) {
        router?.push(`/promotions/${productInfo?.bundlePromoCode}`);
        return;
      }

      if (quantityReminder(productInfo, quantity)) return;

      await continueAddToCart();

    } catch (err) {
      toastMsg(err?.response?.data?.message);
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const continueAddToCart = () => {
    return new Promise(async (resolve, reject) => {
      /**
      *  TEP-14483
      *  當商品中心返回的數據中包含 sop_delivery_frequency_period 時 
      *  走新版本邏輯，获取浏览器缓存 AMW_NON_STRICT_VARIANTS  数据 .split(',') 转换为数组 index 0 为 frequency，index 1 为 cyclePeriod
      * 
      *  當商品中心返回的數據中不包含 sop_delivery_frequency_period 時 
      *  走老版本邏輯 ，获取浏览器缓存 AMW_NON_STRICT_VARIANTS  数据 .split(',') 转换为数组 index 0 为 frequency， 当index 1不存在的情况下 index 0 复值 cyclePeriod
     */
      const nonStrictVariants = getNonStrictVariantsLS();
      const Frequency_CyclePeriod = nonStrictVariants?.delivery_frequency?.split(',')
      const frequency = Frequency_CyclePeriod && Frequency_CyclePeriod !== undefined ? Frequency_CyclePeriod?.length !== 0 && Frequency_CyclePeriod[0] : undefined;
      const cyclePeriod = Frequency_CyclePeriod && Frequency_CyclePeriod !== undefined ? Frequency_CyclePeriod?.length !== 0 && Frequency_CyclePeriod?.length == 1 ? Frequency_CyclePeriod[0] : Frequency_CyclePeriod[1] : undefined;

      /**
       *  TEP-15553 && TEP-15554
       *  获取当前加入主商品的加价购商品信息
      */
      const OPTIONAL_QUANTITY = getMarkupMaxQuantityInfo();//商品可选数量
      const markupPurchaseInfo = getMarkupPurchaseInfo()
      const markupPurchaseArr = markupPurchaseInfo && markupPurchaseInfo[`${MARKUP_PURCHASE}_${itemCode}`]
      const addonPurchaseProducts = (markupPurchaseArr && markupPurchaseArr.length > 0) ? markupPurchaseArr.map(item => {
        return {
          itemCode: item?.itemCode,
          quantity: item?.quantity,
          maxOrderQuantity: JSON.stringify(OPTIONAL_QUANTITY) !== "{}" && OPTIONAL_QUANTITY[item?.itemCode] ? OPTIONAL_QUANTITY[item?.itemCode]?.maxOrderQuantity : ''
        };
      }) : undefined;
      const res = await addToCart(itemCode, quantity, {
        frequency: frequency,
        cyclePeriod: cyclePeriod,
        usePeriod: productInfo?.usePeriod,
        addonPurchaseProducts: addonPurchaseProducts
      });

      if (res?.status === 200) {
        if (updateCartDetails) {
          if (addonPurchaseProducts) {
            /**
              *  TEP-15553 && TEP-15554
              *  当PDP主商品下包含加价购商品时 将加价购商品与主商品一并聚合 抛给min cart
            */
            const list = (markupPurchaseArr && markupPurchaseArr.length > 0) ? markupPurchaseArr.map(item => {
              return {
                product: item,
                quantity: item.quantity
              };
            }) : undefined;
            const products = list && list.length > 0 ? [...list, { product: productInfo, quantity }] : [{ product: productInfo, quantity }]
            /*  ===============================================  TEP-15578 ============================================= */
            const sonList = (markupPurchaseArr && markupPurchaseArr.length > 0) ? markupPurchaseArr.map(item => {
              return item;
            }) : [];
            let masterProduct = { ...productInfo, quantity }
            const productItem = sonList && sonList.length > 0 ? [...sonList, { ...masterProduct }] : [{ ...masterProduct }]

            ttqTrackEventBuryingPoint('addToCart', productItem)
            /*  ===============================================  TEP-15578 ============================================= */
            dispatch(
              updateCartDetails({
                id: "singleProduct",
                totalQuantity: res?.data?.data?.totalQuantity,
                installment:
                  res?.data?.data?.productList?.[0]?.saleAttributes?.find(
                    (attribute) => attribute?.key === "multi_dimension_payment"
                  )?.value,
                products: products,
              })
            );
          } else {
            dispatch(
              updateCartDetails({
                id: "singleProduct",
                totalQuantity: res?.data?.data?.totalQuantity,
                installment:
                  res?.data?.data?.productList?.[0]?.saleAttributes?.find(
                    (attribute) => attribute?.key === "multi_dimension_payment"
                  )?.value,
                products: [{ product: productInfo, quantity }],
              })
            );
          }
          /*  ===============================================  TEP-15578 ============================================= */
          const productItem = [{ ...productInfo, quantity }]
          ttqTrackEventBuryingPoint('addToCart', productItem)
          /*  ===============================================  TEP-15578 ============================================= */
          // analytics - track add to cart
          trackAddToCart([productInfo], [quantity], pageDetails);
        }


        onSuccess && onSuccess(productInfo, quantity);
        resolve();
      } else {
        toastMsg(res?.response?.data?.message);
        reject();
      }
    })

  }

  const [quantityReminderData, setQuantityReminderData] = useState({});
  const [showReminderModal, setShowReminderModal] = useState(false);

  const quantityReminder = (product, quantity) => {

    const whetherItExistsInAnArr = (itemCode) => {
      const REMINDED_ITEM_CODE_ARR = JSON.parse(sessionStorage.getItem('REMINDED_ITEM_CODE_ARR')) ?? []
      return REMINDED_ITEM_CODE_ARR?.length > 0 ? REMINDED_ITEM_CODE_ARR?.includes(itemCode) : false
    }

    const productActivityList = product?.productActivityList;


    // 有活动商品 并且 满足数量 并且 没有打开过弹窗
    if (productActivityList && productActivityList.length != 0) {

      const productList = productActivityList.map((item, index) => {
        const activityConfig = item.activityConfig;
        if (item.activityType == 'popup') {
          const configList = activityConfig.triggerConfigList.map(t => ({
            itemCode: t.popupItemCode,
            number: t.popupTriggerNumber,
          })).filter(f => f.itemCode == product.itemCode && quantity >= f.number);
          return {
            index,
            type: item.activityType,
            title: activityConfig.popupTitle,
            confirmBtnText: activityConfig.popupConfirmWording,
            cancelBtnText: activityConfig.popupCancelWording,
            openCount: activityConfig.popupType,
            confirmUrl: activityConfig.popupConfirmUrl,
            // activityCode: activityConfig.activityCode,
            activityCode: product.itemCode,
            location: activityConfig.popupLocation,
            configList,
          }
        } else {
          const configList = activityConfig.fromToConfigList.map(t => ({
            itemCode: t.switchFromItemCode,
            number: t.switchFromItemQuantity,
          })).filter(f => f.itemCode == product.itemCode && quantity >= f.number);
          return {
            index,
            type: item.activityType,
            title: activityConfig.switchTitle,
            confirmBtnText: activityConfig.switchConfirmWording,
            cancelBtnText: activityConfig.switchCancelWording,
            openCount: activityConfig.switchType,
            // activityCode: activityConfig.activityCode,
            activityCode: product.itemCode,
            fromToConfigList: activityConfig.fromToConfigList,
            location: activityConfig.switchLocation,
            configList
          }
        }
      }).filter(item => {
        // return item.location.includes('plp') || item.location.includes('pdp')
        return item.location.includes('pdp') && item.type == 'popup'
      })
      const configList = productList[0]?.configList;
      if (configList?.length) {
        if ((productList[0].openCount == 'once' && !whetherItExistsInAnArr(product.itemCode)) || productList[0].openCount == 'everytime') {
          setQuantityReminderData(productList[0]);
          setShowReminderModal(true);
          return true;
        }
      }
    }
  }

  const reminderCancel = async (fn) => {
    await continueAddToCart();
    fn();
  }

  //set quantity to one when product changes
  useEffect(() => {
    setQuantity(initialQuantity || 1);
  }, [productInfo, initialQuantity]);

  return (
    <>
      <QuantityReminderPopup
        breakpoint={breakpoint}
        {...quantityReminderData}
        showModal={showReminderModal}
        setShowModal={setShowReminderModal}
        onConfirm={() => setShowReminderModal(false)} // 加购没有 转化提醒
        onCancel={reminderCancel} // 加购没有 转化提醒
      />
      <div className={styles["main-btns-div"]}>
        <div className={styles["quantity-selector-wrapper"]}>
          <QuantitySelector
            disableAddToCart={disableAddToCart}
            button_width={201}
            quantity={quantity}
            onQuantityChange={handleQuantity}
          />
        </div>

        <div className={styles["add-to-cart-wrapper"]}>
          <Cartbtn
            disableAddToCart={disableAddToCart}
            cartIcon={cartIcon}
            cartText="加入購物車"
            button_width={201}
            onAddToCart={addToCartHandle}
            displayCartIcon={false}
            isLoading={isLoading}
            size="sm"
            color="#5E5E5E"
          />
        </div>
      </div>
    </>
  );
}

export default CartButtons;
